import React, {Component} from 'react';

const MOBILE_THRESHOLD = 800;

class ResponsiveLayout extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showMobile: this.shouldShowMobile()
        }
    }

    componentWillMount() {
        window.addEventListener("resize", this.onWindowResized);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onWindowResized);
    }

    onWindowResized = () => {
        this.setState({showMobile: this.shouldShowMobile()});
    }

    shouldShowMobile() {
        return window.innerWidth <= MOBILE_THRESHOLD;
    }

    render() {
        if (this.state.showMobile) {
            return <this.props.mobileLayout {...this.props} />
        }
        return <this.props.desktopLayout {...this.props} />
    }
}

export default ResponsiveLayout;



// WEBPACK FOOTER //
// ./src/components/common/ResponsiveLayout.js